import { types } from "mobx-state-tree";
import { createCustomReadonlyDictionary } from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";
import { MSURL } from "utils/ms";

const workoutPath = "/workouts/api/v1";
export const WorkoutFamilyDictionaryItem = types.model({
  id: types.number,
  title: types.string,
  structureType: types.string,
});

const WorkoutFamilyDictionary = createCustomReadonlyDictionary({
  itemModel: WorkoutFamilyDictionaryItem,
  fetch: async function() {
    const response = await api.get(
      `${workoutPath}/workout-family/slim`,
      undefined,
      undefined,
      MSURL,
    );
    return { items: response };
  },
  getValue: value => value,
  getLabel: ({ title }) => title,
});

export default WorkoutFamilyDictionary.create();
